@if (translationLoaded()) {
  <div class="container">
    <div class="wrapper">
      <div class="logo">
        <img src="assets/img/quantified-colored-logo.svg" alt="{{'login.LOGIN' | transloco}}" />
      </div>
      <div class="body">
        @if (!showSsoLogin()) {
          <div class="welcome-msg">
            <h2>{{'login.TITLE' | transloco}}</h2>
            <p>{{'login.SUB_TITLE' | transloco}}</p>
          </div>
          <div class="cta">
            <div class="sso-login" (click)="toggleSsoLogin()">{{'login.LOGIN_WITH_SSO' | transloco}}</div>
            <div class="login" (click)="login()">{{'login.LOGIN_WITH_PASSWORD' | transloco}}</div>
          </div>
        }
        @if (showSsoLogin()) {
          <div class="welcome-msg">
            <p>{{'login.PROVIDE_EMAIL' | transloco}}</p>
          </div>
          <div class="field">
            <div class="label">{{'login.EMAIL' | transloco}}</div>
            <div class="email" [class.error-highlight]="isEmailError()">
              <input type="email" placeholder="{{'login.EMAIL_PLACEHOLDER' | transloco}}" (input)="validateEmail()" [(ngModel)]="email" />
              @if (isEmailError()) {
                <img src="assets/icons/alert-circle.svg" alt="{{'login.ALERT' | transloco}}" />
              }
            </div>
            @if (showRegionRecoveryMessage()) {
              <div class="error">
                {{ wrongRegionMessage }}
                <a [href]="alternateRegionLoginUrl" rel="noopener noreferrer">{{ wrongRegionLink }}</a>
              </div>
            } @else if (isEmailError()) {
              <div class="error">{{ error }}</div>
            }
          </div>
          <div class="cta">
            <div class="login" (click)="ssoLogin(email)" [class.disabled]="email.length === 0"
              [attr.disabled]="email.length === 0 ? true : null">{{'login.LOGIN' | transloco}}</div>
          </div>
        }
        <div class="footer">
          @if (!showSsoLogin()) {
            <p class="concent" [innerHTML]="consentMessage"></p>
          }
          <p>{{'login.HELP_TEXT'| transloco}} <a
              [href]="'mailto:help@quantified.ai?subject=Login%20Issue'">help&#64;quantified.ai</a></p>
        </div>
      </div>
    </div>
  </div>
}
